
import { request } from 'utils/request';
// 证书列表
export const PostMemberAttestation = (postData) =>
  request('/official/memberAttestation/list', 'POST', postData)
// 会员列表
export const PostMemberList = (postData) =>
  request('/official/member/list', 'POST', postData)